module.exports = __webpack_public_path__ + "static/media/Waiter.5fdc24d6.jpg";